import React, { useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { importDetails } from "./../graphql/queries/landlordQueries";
import { startImportMutation } from "./../graphql/mutations/landlordMutations";
import {
  PageContainer,
  BlockContainer,
  Row,
  Col,
  FormContainer,
  FormData,
} from "./../moose-ui/Layout";

const IMPORT_DETAILS = gql(importDetails);
const START_IMPORT = gql(startImportMutation);

const ImportProgressModal = ({
  importId,
  isVisible,
  onComplete = () => {},
}) => {
  const [startWatching, { called, loading, data }] = useLazyQuery(
    IMPORT_DETAILS,
    {
      variables: {
        id: importId,
      },
      pollInterval: 500,
      fetchPolicy: "network",
      onCompleted: (result) => {},
      onError: (e) => {},
    }
  );

  const [
    startImport,
    { data: importResult, loading: isImporting, error: importingError },
  ] = useMutation(START_IMPORT, {
    variables: { id: importId },
    onCompleted: (result) => {
      onComplete();
    },
    onError: (e) => {
      alert("Error while importing. Contact system admin.");
    },
  });

  useEffect(() => {
    if (importId > 0) {
      startWatching();
      startImport();
    }
  }, [importId]);

  const visibilityStyle = isVisible ? "" : "hidden";
  const overlayIndex = isVisible ? 100 : -10000;

  return (
    <div
      className={`${visibilityStyle} fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center`}
      style={{ zIndex: overlayIndex }}
    >
      <div className={`${visibilityStyle} fixed inset-0 transition-opacity`}>
        <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>

      <div
        className={`${visibilityStyle} bg-white rounded-lg px-4 pt-5 pb-4 shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6`}
      >
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              User Import Progress {importId}
            </h3>
            {data && data.import && (
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%" }}>Total: {data.import.total}</td>
                    <td>Processed: {data.import.processed}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%" }}>
                      Imported: {data.import.imported}
                    </td>
                    <td>Duplicates: {data.import.duplicates}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "50%" }}>
                      Failed: {data.import.failed}
                    </td>
                    <td>Unresolved: {data.import.unresolved}</td>
                  </tr>
                  <tr>
                    <td>Progress: {data.import.progress}%</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
        </div>
        {/* <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button
              type="button"
              className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5"
              onClick={onComplete}
            >
              Close
            </button>
          </span>
        </div> */}
      </div>
    </div>
  );
};

export default ImportProgressModal;
